import { toast } from 'react-toastify';
import actions from '../../constants/actionTypes';
import request from '../../utils/request';
import { startAppLoading, stopAppLoading } from '../../layout/actions';
import { trans } from '../../localization/index';
import { isSuccess } from '../../utils/utils';
import { setGeneralError } from '../../layout/components/UniversalModal/actions';
import { closeDialogGeneric } from '../../redux/genericAction';
import { EnumPage } from '../../constants/enum';

export function openCreateStaffModal(itemDetail) {
  return {
    type: actions.OPEN_CREATE_STAFF_MODAL,
    response: {
      itemDetail,
    },
  };
}

export function getListStaffRestaurant() {
  function genBody(state) {
    const { filters } = state;
    const { restaurant } = filters;
    const body = {
      restaurant_id: restaurant.value,
    };
    return body;
  }

  return (dispatch, getState) => {
    const state = getState().staff;
    const body = genBody(state);
    if (body.restaurant_id === 0) {
      return null;
    }
    dispatch(startAppLoading());
    return request.getMerchant('/api/staff/get_list', body).then((response) => {
      if (isSuccess(response)) {
        const { staff_list: itemList = [] } = response.reply;
        dispatch({
          type: actions.RECEIVE_LIST_STAFF,
          response: {
            itemList: itemList.sort((a, b) => (a.is_me < b.is_me ? 1 : -1)),
          },
        });
      } else {
        dispatch(setGeneralError(trans(response.result)));
      }
      return dispatch(stopAppLoading());
    });
  };
}

export function createStaff(body) {
  return (dispatch) => {
    dispatch(startAppLoading());
    return request.postMerchant('/api/staff/create', body).then((response) => {
      if (isSuccess(response)) {
        dispatch(closeDialogGeneric(EnumPage.SETTING_STAFF.id));
        dispatch(getListStaffRestaurant());
        toast.success(trans('set_staff_create_success'));
      } else {
        dispatch(setGeneralError(trans(response.result)));
      }
      return dispatch(stopAppLoading());
    });
  };
}

export function updateStaff(body) {
  return (dispatch) => {
    dispatch(startAppLoading());
    return request.postMerchant('/api/staff/update', body).then((response) => {
      if (isSuccess(response)) {
        dispatch(closeDialogGeneric(EnumPage.SETTING_STAFF.id));
        dispatch(getListStaffRestaurant());
        toast.success(trans('set_staff_update_success'));
      } else {
        dispatch(setGeneralError(trans(response.result)));
      }
      return dispatch(stopAppLoading());
    });
  };
}



// WEBPACK FOOTER //
// ./foody/src/pages/Staff/actions.js